import React from 'react';

// The Ditio wordmark (NOT the Core product "C" logo). Inlined so it matches the
// exact same wordmark the branded emails and PDFs use for their "Generated by Ditio"
// mark. fill=currentColor + the footer's opacity render it muted grey.
export const DitioMark = (
  props: React.SVGProps<SVGSVGElement>
): React.JSX.Element => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 186 48"
    fill="currentColor"
    role="img"
    aria-label="Ditio"
    {...props}
  >
    <path d="M161.492 38.5899C153.033 38.5899 147.227 32.6002 147.227 23.8672C147.227 15.1342 153.033 9.14452 161.492 9.14452C169.951 9.14452 175.758 15.1342 175.758 23.8672C175.758 32.6002 169.951 38.5899 161.492 38.5899ZM120.799 46.7285H129.944V1.0059H120.799V46.7285ZM95.5145 10.1504H113.804V1.0059H95.5145V10.1504ZM68.0809 10.1504H86.37V1.0059H68.0809V10.1504ZM86.37 46.7285H95.5145V10.1504H86.37V46.7285ZM51.9409 46.7285H61.0854V1.0059H51.9409V46.7285ZM0 46.7285H18.289C34.612 46.7285 44.2137 38.2241 44.2137 23.8672C44.2137 9.5103 34.612 1.0059 18.289 1.0059H0V19.2949H9.14452V10.1504H18.289C29.3539 10.1504 34.9778 14.7684 34.9778 23.8672C34.9778 32.966 29.3539 37.584 18.289 37.584H9.14452V28.4395H0V46.7285ZM9.14452 28.4395H18.289V19.2949H9.14452V28.4395ZM161.492 47.7344C174.843 47.7344 185.359 37.2182 185.359 23.8672C185.359 10.5162 174.843 0 161.492 0C148.141 0 137.625 10.5162 137.625 23.8672C137.625 37.2182 148.141 47.7344 161.492 47.7344Z" />
  </svg>
);
